import React from 'react'
import { AdminDayBook } from './Partials/AdminDayBook'

export const DayBook_MainOffice = () => {
  return (
    <AdminDayBook />
  )
}
